import { useSwipeable } from 'react-swipeable';

export interface SwipeHandlerProps {
  leftSwipeEnabled: boolean;
  rightSwipeEnabled: boolean;
  onSwipeLeft: () => void;
  onSwipeRight: () => void;
}

const useSwipeHandlers = ({
  leftSwipeEnabled,
  rightSwipeEnabled,
  onSwipeLeft,
  onSwipeRight,
}: SwipeHandlerProps) => {
  const onSwipedLeft = () => {
    if (leftSwipeEnabled) {
      onSwipeLeft();
    }
  };

  const onSwipedRight = () => {
    if (rightSwipeEnabled) {
      onSwipeRight();
    }
  };

  const handlers = useSwipeable({
    onSwipedLeft,
    onSwipedRight,
    delta: 100,
    preventScrollOnSwipe: true,
    trackMouse: false,
    trackTouch: true,
    rotationAngle: 0,
    swipeDuration: 500,
  });

  return handlers;
};

export default useSwipeHandlers;
